import DateSelector from "../../../components/DateSelector";
import CalendarPicker from "../../../components/CalendarPicker";

const DateSelectorComponent = ({ event, ticketSelection, selectDate }) => {
  if (event.data.datesUseCalendar) {
    return (
      <CalendarPicker
        selectedDateId={ticketSelection.selectedDateId}
        selectedStartDate={ticketSelection.selectedStartDate}
        selectedDateDisplay={ticketSelection.selectedDateDisplay}
        selectDate={selectDate}
      />
    );
  }
  return (
    <DateSelector
      selectedDateId={ticketSelection.selectedDateId}
      dates={event.data.dates}
      selectDate={selectDate}
      name="Select event date"
    />
  );
};

export default DateSelectorComponent;



// WEBPACK FOOTER //
// ./routes/tickets/components/DateSelectorComponent.js